import { EmployeeRole, EmployeeStatus } from '@/types';
import {
  EmployeeSummaryCounts,
  RestaurantEmployee,
} from '@sales-portal/domain/accounts/screens/employee-list/types';

/**
 * Partitions a list of employees into the counts displayed in the summary
 * sidebar: admins, users, pending invites, and total.
 *
 * Invited employees are counted under `inviteCount` regardless of role — an
 * invited admin is surfaced as a pending invite, not as an admin, so viewers
 * don't see seats they can't yet act on.
 *
 * @param employees - The full list of employees (post authenticated-user filter)
 * @returns `adminCount`, `userCount`, `inviteCount`, and `totalCount`
 */
export const getEmployeeSummary = (
  employees: RestaurantEmployee[],
): EmployeeSummaryCounts => {
  let adminCount = 0;
  let userCount = 0;
  let inviteCount = 0;

  for (const employee of employees) {
    if (employee.employee_status === EmployeeStatus.Invited) {
      inviteCount++;
      continue;
    }
    // Any non-admin role (User, Cashier, DSM, SupplierDefault, or a role
    // introduced later) rolls up under "Users" so the sidebar totals always
    // equal totalCount.
    if (employee.restaurant_employee_role === EmployeeRole.Admin) {
      adminCount++;
    } else {
      userCount++;
    }
  }

  return {
    adminCount,
    inviteCount,
    totalCount: employees.length,
    userCount,
  };
};
